var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',[_c('h1',{staticClass:"py-3"},[_vm._v(_vm._s(_vm.item.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.item.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }